import { render, staticRenderFns } from "./vermAseg.vue?vue&type=template&id=b89b45e4&scoped=true"
import script from "./vermAseg.vue?vue&type=script&lang=js"
export * from "./vermAseg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b89b45e4",
  null
  
)

export default component.exports